import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { TimeAccuracy } from '../../../../../form-controls/entities/time-accuracy.entity';
import { BatchFieldReadHelper } from '../../../../helpers/fields/batch-field-read-helper';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSimpleInputFieldComponent } from '../simple-input-field/simple-input-field.component';

@Component({
    selector: 'sh-time-code-field',
    templateUrl: './time-code-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShTimeCodeInputFieldComponent extends ShSimpleInputFieldComponent {
    public timeAccuracy: TimeAccuracy = TimeAccuracy.MILLISECONDS;
    constructor(protected fieldHelper: FieldReadHelper) {
        super(fieldHelper);
    }

    init(profileField: ExtendedBaseProfileField, records: PartialRecord[], control: UntypedFormControl): void {
        const mergedTimeCodeField = this.isBatchEdit
            ? BatchFieldReadHelper.getBatchFieldValue(profileField.FieldDefinition)
            : this.fieldHelper.getMergedTimeCodeFieldValue(profileField.FieldDefinition, records);

        control.setValue(mergedTimeCodeField);
    }
}
